import { ChangeDetectionStrategy, Component, HostListener, input, output } from '@angular/core';

export type ModalSize = 'sm' | 'md' | 'lg';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'ui-modal',
  styleUrl: './modal.scss',
  templateUrl: './modal.html',
})
export class ModalComponent {
  /** Contrôle l'ouverture de la modale. */
  readonly open = input(false);

  /** Titre affiché dans l'en-tête. */
  readonly title = input('');

  /** Largeur de la boîte de dialogue. */
  readonly size = input<ModalSize>('md');

  /** Ferme la modale lors d'un clic sur l'arrière-plan. */
  readonly closeOnBackdrop = input(true);

  /** Ferme la modale à la pression de la touche Échap. */
  readonly closeOnEscape = input(true);

  /** Émis lorsque l'utilisateur demande la fermeture. */
  readonly close = output<void>();

  @HostListener('document:keydown.escape')
  protected onEscape(): void {
    if (this.open() && this.closeOnEscape()) {
      this.close.emit();
    }
  }

  protected onBackdrop(): void {
    if (this.closeOnBackdrop()) {
      this.close.emit();
    }
  }
}
